import Axios from "axios";
import { CSR_ASSIGNMENT_SETTINGS, SET_ERROR, } from "../../types";


export const getCsrAssignmentSettings = () => async (dispatch) => {
    let CsrAssignmentsList = await Axios.get('api/csr/csr-assignment-settings');
    let { data } = CsrAssignmentsList;
    if (!data.capacityLevels) data.capacityLevels = [];
    dispatch({ type: CSR_ASSIGNMENT_SETTINGS, payload: data });
};

export const addUpdateCsrAssignmentSettings = (data) => async (dispatch) => {
    await Axios.post('api/csr/add-update-settings', { data });
    await dispatch({ type: CSR_ASSIGNMENT_SETTINGS, payload: data });
};